// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {CalendarIntegrationModel} from '@supermove/models';

// App
import WarningModal from '@shared/design/components/Modal/SmallModal/WarningModal';

interface DeleteCalendarIntegrationModalProps {
  calendarIntegration: CalendarIntegrationModel;
  isOpen: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
}

const QuiteEditingCalendarIntegrationModal = ({
  calendarIntegration,
  isOpen,
  handleSubmit,
  handleClose,
}: DeleteCalendarIntegrationModalProps) => {
  return (
    <WarningModal
      isOpen={isOpen}
      title={`Quit editing "${calendarIntegration.accountCalendar.calendarName}"?`}
      message={'Your updates will not be saved. This action cannot be undone.'}
      primaryActionText={'Confirm'}
      secondaryActionText={'Cancel'}
      handlePrimaryAction={handleSubmit}
      handleSecondaryAction={handleClose}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
QuiteEditingCalendarIntegrationModal.fragment = gql`
  fragment QuiteEditingCalendarIntegrationModal on CalendarIntegration {
    id
    accountCalendar {
      id
      calendarName
    }
  }
`;

export default QuiteEditingCalendarIntegrationModal;
